module.exports = __webpack_public_path__ + "img/ellipse-particulier_2x.d4b85e9d.webp";